<template>
  <BittsButton
    :text="onlyShowIcon ? undefined : text"
    :type="activated ? 'upsell' : 'neutral'"
    :left-icon="leftIconValue"
    :center-icon="centerIconValue"
    :disabled
    size="small"
    variant="outline"
    class="bitts-simple-filter-button"
    :class="{
      'bitts-simple-filter-button__active': filterVisible,
    }"
  >
    <template #extra-content>
      <BittsCount :count type="upsell" :class="{ 'ml-4 mt-2': count }" />
    </template>
  </BittsButton>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import BittsButton from '../../BittsButton/BittsButton.vue';
import BittsCount from '../../BittsCount/BittsCount.vue';
import { BittsIcon } from '../../types';

const {
  activated = false,
  count,
  filterVisible = false,
  text,
  icon,
  disabled = false,
  onlyShowIcon = false,
} = defineProps<{
  activated?: boolean;
  count?: number;
  filterVisible: boolean;
  text: string;
  icon: BittsIcon;
  disabled?: boolean;
  onlyShowIcon?: boolean;
}>();

const leftIconValue = computed(() => {
  return (!onlyShowIcon || (activated && count)) && icon ? icon : undefined;
});

const centerIconValue = computed(() => {
  return onlyShowIcon && (!activated || !count) && icon ? icon : undefined;
});
</script>

<style scoped lang="pcss">
.bitts-simple-filter-button__active {
  outline: 2px solid theme(colors.neutral.border-focus);
}
</style>
